import React from 'react'
import PropTypes from 'prop-types'
import InfoGraphicCounter from './InfoGraphicCounter'
import AjaxLoader from './AjaxLoader'

const HomeSecureTopThreats = (props) => {
    const Loader = (
        <div className='col-12 d-flex justify-content-center align-items-center'>
            <AjaxLoader />
        </div>
    )

    return (
        <div className='row'>
            <div className='col-12 col-md-8 offset-md-2 text-center mb-5'>
                {props.children}
            </div>
            {!props.isLoadingDuration
                ? <React.Fragment>
                    <div className='col-12 d-flex mb-lg-5 justify-content-center flex-column flex-lg-row'>
                        <div className='mr-lg-5 mb-4 mb-lg-0'>
                            <InfoGraphicCounter count={props.virusCount} title='Blocked viruses' icon='home-secure/icon-anti-virus1.svg' />
                        </div>
                        <div className='mb-4 mb-lg-0'>
                            <InfoGraphicCounter count={props.malwareCount} title='Blocked malware' icon='home-secure/icon-anti-malware1.svg' />
                        </div>
                    </div>
                    <div className='col-12 d-flex mb-lg-5 justify-content-center flex-column flex-lg-row'>
                        <div className='mr-lg-5 mb-4 mb-lg-0'>
                            <InfoGraphicCounter count={props.phishingCount} title='Blocked phishing' icon='home-secure/icon-anti-phishing1.svg' />
                        </div>
                        <div className='mb-4 mb-lg-0'>
                            <InfoGraphicCounter count={props.contentCount} title='Blocked content' icon='home-secure/icon-content-filter.svg' />
                        </div>
                    </div>
                    <div className='col-12 col-lg-10 offset-lg-1 text-center'>
                        <p className='m-0 mb-2 bold lh'>{props.duration === 'last30d' ? 'This report is updated daily @ 12AM' : 'This report is updated hourly'}</p>
                        <p className='m-0 lh'>
                            Malicious websites often include multiple hidden requests for forbidden content that take place in the background, without you even noticing. This means that each time you are blocked from visiting a dangerous website, Home Secure actually blocks several pages and forbidden requests made by the domain in the background. As a result, the total number of blocking events shown here is much higher than the number of blocked website messages you are shown while browsing.
                        </p>
                    </div>
                  </React.Fragment>
                : Loader}
        </div>
    )
}

HomeSecureTopThreats.propTypes = {
    virusCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    malwareCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    phishingCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    contentCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    isLoadingDuration: PropTypes.bool,
    duration: PropTypes.oneOf(['last24h', 'last7d', 'last30d'])
}

HomeSecureTopThreats.defaultProps = {
    virusCount: 0,
    malwareCount: 0,
    phishingCount: 0,
    contentCount: 0
}

export default HomeSecureTopThreats



// WEBPACK FOOTER //
// ./resources/js/components/HomeSecureTopThreats.js